import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import classNames from "classnames";
import { StatusIcon } from "../StatusIcon/StatusIcon";
import { Icon } from "../Icon/Icon";
import { Button } from "../Button/Button";
export const Snack = ({ id, className, status = "info", onDismiss, hideDismiss, customIcon, children, ...rest }) => {
    const { autoDismissDuration = hideDismiss ? 5000 : undefined, ...htmlAttributes } = rest;
    useEffect(() => {
        if (autoDismissDuration) {
            setTimeout(() => {
                onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss(id);
            }, autoDismissDuration);
        }
    }, [autoDismissDuration, onDismiss]);
    return (_jsxs("div", { className: classNames("eds-snack", className), "aria-live": "polite", role: "status", id: id, ...htmlAttributes, children: [customIcon || _jsx(StatusIcon, { status: status }), _jsx("div", { className: "eds-snack__body", children: children }), !hideDismiss && (_jsx(Button, { variant: "ghost", onClick: () => {
                    onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss(id);
                }, "aria-label": "Close", children: _jsx(Icon, { name: "Close" }) }))] }));
};
